import React from "react";
import { Box, Button, Container, TextField, Divider, List } from "@mui/material";
import MovementData from "./MovementData";
import { FechaFormateada, getColorFontRow, getColorRow } from "../helpers";

const Movements = ({ movements, readonly = false }) => {
  return (
    <List sx={{ width: '100%', background:'red', bgcolor: 'background.paper' }}>
      {movements && movements.map(movement => <>
          <MovementData
            key={movement.article_id} 
            data={{
              id: movement._id,
              user: movement.user,
              description: movement.description,
              date: FechaFormateada(movement.created_at),
              type: movement.type,
              price: movement.amount
            }}
            onRemove={() => {}}
            colors={{background: `${getColorRow(movement)}`, font: `${getColorFontRow(movement)}`}}
          />
          <Divider variant="inset" component="li" />
        </>
      )}
    </List>
  )
}

export default Movements;